// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"538b95f2","59":"0ed1cc7b","563":"862c277e"}[chunkId] + ".css";
};